import React from 'react';
import '../scss/style.scss';

const FlexPicture = props => (
  <>
    <picture>
      <source
        srcSet={`/images/2x/${props.icon}@2x.png`}
        media="(min-resolution: 2dppx)"
      />
      <img
        className={props.className}
        src={`/images/1x/${props.icon}@1x.png`}
        title={props.name}
        alt={props.name}
        loading="lazy"
      />
    </picture>
  </>
);

export default FlexPicture;
